import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-switcher">
          <button 
            className={`lang-button ${i18n.language === 'en' ? 'active' : ''}`} 
            onClick={() => changeLanguage('en')}
            aria-label={t('accessibility.switchToEnglish')}
          >
            EN
          </button>
          <button 
            className={`lang-button ${i18n.language === 'sq' ? 'active' : ''}`} 
            onClick={() => changeLanguage('sq')}
            aria-label={t('accessibility.switchToAlbanian')}
          >
            SQ
          </button>
    </div>
  );
};

export default LanguageSwitcher;
